<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.progress_evaluation'),
                        href: meta.links.index,
                    },
                    {
                        name: progressEvaluation.category_name,
                        href: meta.links.category_index,
                    },
                    {
                        name: group.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex justify-end space-x-2">
            <AppButton
                desired-action
                element="InertiaLink"
                :href="meta.links.compare_with_previous_year"
                v-if="meta.can.compare_with_previous_year"
            >
                {{ $t('messages.compare_with_previous_year') }}
            </AppButton>

            <AppButton desired-action v-if="meta.can.create" :href="meta.links.create" element="InertiaLink">
                {{ $t('messages.grade_activity') }}
            </AppButton>
            <AppButton desired-action v-else-if="meta.can.compare" :href="meta.links.compare" element="InertiaLink">
                {{ $t('messages.show_comparison') }}
            </AppButton>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.date') }}
                                </th>
                                <th
                                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.actions') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(progressEvaluationGroup, index) in progressEvaluationGroups"
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                :key="progressEvaluationGroup.id"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ progressEvaluationGroup.date }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-right text-sm leading-5 font-medium flex gap-x-2 justify-end"
                                >
                                    <InertiaSquareLinkButton action="show" :href="progressEvaluationGroup.links.show" />
                                    <InertiaSquareLinkButton action="edit" :href="progressEvaluationGroup.links.edit" />
                                    <InertiaSquareDeleteButton
                                        :href="progressEvaluationGroup.links.delete"
                                        :confirm-text="$t('messages.are_you_sure?')"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'group', 'progressEvaluation', 'progressEvaluationGroups'],
};
</script>
